export default __webpack_public_path__ + "static/media/img_1.e088e734.png";